module.exports = __webpack_public_path__ + "img/next.79b21c25.png";